var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "sidemenu off-canvas-menu menu_is_open" }, [
    _c(
      "div",
      { staticClass: "menu__list-container" },
      [
        _vm._l(_vm.navigation, function (nav, idx) {
          return _c(
            "div",
            { staticClass: "nav", attrs: { index: idx } },
            [
              !nav.url
                ? _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle",
                          value: "nav-" + idx,
                          expression: "`nav-` +idx",
                        },
                      ],
                      staticClass: "nav-header",
                      attrs: { block: "", variant: "link" },
                      on: {
                        click: function ($event) {
                          nav.visible = !nav.visible
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center" },
                        [
                          _c("b-icon", {
                            staticClass: "mr-3",
                            attrs: {
                              icon:
                                nav.icon !== null
                                  ? nav.icon
                                  : "layout-text-window-reverse",
                            },
                          }),
                          _vm._v(_vm._s(nav.header)),
                        ],
                        1
                      ),
                      _c("b-icon-chevron-up"),
                      _c("b-icon-chevron-down"),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "b-collapse",
                { attrs: { id: "nav-" + idx, visible: idx === 0 } },
                [
                  _c(
                    "ul",
                    { staticClass: "menu__list--primary" },
                    _vm._l(nav.navigationItems, function (navItem) {
                      return _c("li", [
                        _c("a", { attrs: { href: navItem.url } }, [
                          _vm._v(_vm._s(navItem.label)),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]
              ),
              nav.url
                ? _c(
                    "a",
                    {
                      staticClass: "nav-header",
                      attrs: { href: nav.url, block: "" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-items-center" },
                        [
                          _c("b-icon", {
                            staticClass: "mr-3",
                            attrs: {
                              icon:
                                nav.icon !== null
                                  ? nav.icon
                                  : "layout-text-window-reverse",
                            },
                          }),
                          _vm._v(_vm._s(nav.header)),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        _c("hr"),
        _c(
          "div",
          {
            staticClass: "menu__logout-button",
            on: {
              click: function ($event) {
                return _vm.logUserOutCb()
              },
            },
          },
          [
            _c(
              "button",
              { staticClass: "nav-header primary", attrs: { variant: "link" } },
              [
                _c("b-icon-x-square-fill", {
                  staticClass: "mr-3 text-brand-light",
                }),
                _c("div", { domProps: { innerHTML: _vm._s(_vm.logOutText) } }),
              ],
              1
            ),
            _c("div", { staticClass: "menu_footer" }),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }